export enum Position {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export type MultiSelectOptionType = {
  id: string;
  value: string;
  active: boolean;
};
